import { render, staticRenderFns } from "./EditDictDialog.vue?vue&type=template&id=a949f43a&"
import script from "./EditDictDialog.vue?vue&type=script&lang=js&"
export * from "./EditDictDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports